import { PropsWithChildren } from 'react';

type Props = {
  title: string;
  onClose: () => void;
};

export function Modal({ title, onClose, children }: PropsWithChildren<Props>) {
  return (
    <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:50}} onClick={onClose}>
      <div className="card" style={{width:'min(1000px, 90vw)', maxHeight:'90vh', overflow:'auto'}} onClick={e=>e.stopPropagation()}>
        <div className="toolbar">
          <div className="title"><h3 style={{margin:0}}>{title}</h3></div>
        </div>
        {children}
      </div>
    </div>
  );
}


